import PageHero from "@/components/PageHero";
import { Shield, Activity, GraduationCap, HeartPulse, Building2, Users } from "lucide-react";

const PILLARS = [
  { icon: Shield, t: "Doctor Safety", d: "Hospital security audits, anti-violence protocols, and council-backed legal aid." },
  { icon: HeartPulse, t: "Welfare Schemes", d: "Insurance, mental-health support, and emergency fund for practitioners in distress." },
  { icon: Activity, t: "Modern Practice", d: "Telemedicine norms, AI-ethics charter, and CME credit modernisation." },
  { icon: GraduationCap, t: "Mentorship", d: "Structured mentor matching for young doctors entering practice in Delhi." },
  { icon: Building2, t: "Transparent Council", d: "Public dashboards, RTI-first culture, and live tracking of complaints." },
  { icon: Users, t: "Patient Trust", d: "Ethical practice charter and rapid resolution of legitimate grievances." },
];

export default function Vision() {
  return (
    <div data-testid="vision-page">
      <PageHero
        eyebrow="Vision · Manifesto"
        title="A future where every doctor is heard, supported, and respected."
        subtitle="Six pillars. One pledge. Build a Delhi Medical Council that works — for practitioners and the public alike."
      />
      <section className="section-y">
        <div className="container-x">
          <div className="grid md:grid-cols-12 gap-6">
            {PILLARS.map((p, i) => (
              <div key={i} className={`card-flat ${i % 5 === 0 ? "md:col-span-8" : "md:col-span-4"}`} data-testid={`vision-pillar-${i}`}>
                <p.icon className="text-[hsl(var(--accent))]" size={36} />
                <h3 className="font-display text-2xl mt-4 text-[hsl(var(--primary))]">{p.t}</h3>
                <p className="mt-2 text-[hsl(var(--fg-muted))] leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>

          <div className="mt-20 bg-[hsl(var(--primary))] text-white p-10 sm:p-16">
            <div className="label-eyebrow text-white/80 mb-3">Policy Improvements</div>
            <h2 className="font-display text-3xl sm:text-5xl">A 12-point reform agenda.</h2>
            <ol className="mt-8 grid md:grid-cols-2 gap-x-12 gap-y-4 list-decimal pl-5 text-white/90">
              {[
                "Online registration and renewal portal",
                "Complaint tracking with SLA-bound resolution",
                "Free legal counsel for council-defended doctors",
                "Open council expenditure dashboard",
                "Ethics charter & AI-medicine guidelines",
                "Women-doctor safety audits across hospitals",
                "Mentor-match for first-five-years practitioners",
                "Quarterly council town halls (open to public)",
                "Streamlined CME credit recognition",
                "Patient grievance mediation cells",
                "Digital-first communications (multi-language)",
                "RTI-ready data publishing standards",
              ].map((x, i) => (
                <li key={i}>{x}</li>
              ))}
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
}
